import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.175 4.001a.73.73 0 0 0-.73.73v1.54a2.063 2.063 0 0 1 0 3.905v1.54a.73.73 0 0 0 .73.73h6.317v-.73a.667.667 0 1 1 1.334 0v.73h2.127a.73.73 0 0 0 .73-.73v-1.54a2.064 2.064 0 0 1 0-3.905V4.73a.73.73 0 0 0-.73-.73h-2.127v.73a.667.667 0 0 1-1.334 0v-.73zm0-1.333A2.063 2.063 0 0 0 1.11 4.731v2.096c0 .368.299.666.667.666a.73.73 0 1 1 0 1.46.667.667 0 0 0-.667.667v2.096a2.063 2.063 0 0 0 2.064 2.063h9.778a2.063 2.063 0 0 0 2.063-2.063V9.62a.667.667 0 0 0-.667-.666.73.73 0 0 1 0-1.46.667.667 0 0 0 .667-.667V4.73a2.063 2.063 0 0 0-2.063-2.063zm6.984 4.19c.368 0 .667.299.667.667v1.397a.667.667 0 0 1-1.334 0V7.525c0-.368.299-.667.667-.667",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }